module.exports = __webpack_public_path__ + "img/myguard_pro_04.5f78f3bb.png";